import { NavLink } from "react-router"

const NAVLINK_ONLY = [
    "to",
    "end",
    "caseSensitive",
    "reloadDocument",
    "replace",
    "state",
    "preventScrollReset",
    "relative",
];

export default function ToggleableNavLink({ disabled = false, children, ...props }) {
    if (disabled) {
        const divProps = Object.fromEntries(
            Object.entries(props).filter(([k]) => !NAVLINK_ONLY.includes(k))
        );
        return <div {...divProps} >
            {children}
        </div>
    } else {
        return <NavLink  {...props}>
            {children}
        </NavLink>
    }
}